import { React, useState } from 'react';
import './Landingpage.css';
import ApprovalTable from '../ApprovalAdmin/ApprovalPage';
import images from "./img/images.jpg";
import usbimages from "./img/USB.jpg";
import tsimages from "./img/timebg.png";
import image1 from "./img/login-page.jpg";
import logoutimg from "./img/logout.png";
import image from "./img/switch.png";
import eolimages from "./img/EOL.png";
import ionimages from "./img/ion.png";
import darwinimages from "./img/darwin.png";
import pjdimages from "./img/projectdash.png";
import reporticon from "./img/report_img.png";
import onlineimages from "./img/onlineapproval.png";
import econnectimages from "./img/econnect.png";
import clmimages from "./img/clm.png";
import Tableau from '../Tableau/index'
import swimages from './img/swImg.jpg'
import vpnimages from './img/vpnimages.jpg'
export default function LandingPageDashboard() {
    const [role, setRole] = useState(sessionStorage.getItem("role"))
    const onLeaveTab = () => {
        window.location.href = "/LeaveRequest"
    }
    const assetrequest = () => {
        window.location.href = "/assetrequest"
    }
    const vendormaster = () => {
        window.location.href = "/timetracker"
    }
    const redirectToLogin = () => {
        window.location.href = "/login"
    }
    const redirectMyContract = () => {
        window.open('https://clm.switchmobilityev.com/', '_blank')
        // window.location.href = "https://clm.switchmobilityev.com/"
    }
    const redirectOnlineapproval = () => {
        window.open('https://onlineapproval.switchmobilityev.com/', '_blank')
        // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
    }
    const projectdashboard = () => {
        window.open('https://projectdashboard.switchmobilityev.com/', '_blank')
        // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
    }
    const leymobile = () => {
        window.open('https://econnect.ashokleyland.com/login.jsp', '_blank')
        // window.location.href = "https://onlineapproval.switchmobilityev.com/ "
    }

    const redirectusercreation = () => {
        window.location.href = "/registration"
    }
    const redirectusbactivation = () => {
        window.location.href = "/request_activate"
    }
    const softwareRqFn = () => {
        window.location.href = "/software_access"
    }
    const vpnRqFn = () => {
        window.location.href = "/vpn_access"
    }
    const eolfun = () => {
        alert("Coming Soon")
        {/*window.location.href = "/EOL"*/ }
    }
    const darwinfn = () => {
        window.open('https://ashokleyland.darwinbox.in/user/login', '_blank')
    }
    const switchionfn = () => {
        window.open('http://ialertev.ashokleyland.com/', '_blank')
    }

    const tableau = () => {
        alert("Coming Soon")
        {/*window.location.href = "/powerreport"*/ }
    }
    return (
        <>

            {/* <div className="landing-parent" style={{backgroundImage:`linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),url(${image1})`,backgroundRepeat:"no-repeat"}}> style={{backgroundImage:`linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5))`,backgroundColor:"cadetblue",backgroundRepeat:"no-repeat"}}*/}
            <div className="landing-parent bg_set_land" >

                <div></div>
                {/* <Tableau/> */}
                <div className="switch" >
                    <img className="switch-img" src={image} />
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg} />
                </div><br /><br />
                <div className="landing">
                    <div style={{ display: 'flex' }}>
                        <div className="topLandingDiv" onClick={vendormaster}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={tsimages} /><br />
                        </div>
                        <div className="assetbox"><p align="center">Time hello Tracker</p></div>

                        <div className="sideLandingDiv" onClick={redirectusbactivation}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={usbimages} /><br />
                        </div>
                        <div className="usbimg"><p align="center">USB Access</p></div>
                        <div className="sideLandingDiv" onClick={softwareRqFn}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={swimages} /><br />
                        </div>
                        <div className="swimg"><p align="center">Software Access</p></div>
                        <div className="sideLandingDiv" onClick={eolfun}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={eolimages} /><br />
                        </div>
                        <div className="vpnimg"><p align="center">End Of Line</p></div>
                        <div className="sideLandingDiv" onClick={tableau}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={reporticon} /><br />
                        </div>
                        <div className="tsimg"><p align="center">Performance Report</p></div>
                        {/* <div className="topLandingDiv" onClick={vendormaster}><p align="center">Vendor Master</p><span> <img src="https://ashokleyland.darwinbox.in/themes/bootstrap/images/favicon.ico" ></img></span></div> */}
                        {/* <div className="sideLandingDiv" onClick={vendormaster}><p align="center">Time Tracker</p><span> </span></div> */}
                        {/* <div className="sideLandingDiv" onClick={eolfun}>
                        <img className=""  style={{borderRadius:"20px",width:"104%"}}src={eolimages}/><br/>
                            </div>
                            <div className="eolimg"><p align="center">End Of Line</p></div> */}
                        {/* <div className="topLandingDiv" onClick={eolfun}><p align="center">EOL</p></div> */}
                        {/* <div className="topLandingDiv" onClick={redirectusercreation}><p align="center">Create DBM User</p></div> */}


                    </div><br />
                    <div className="" style={{ display: 'flex' }}>
                        {/* <div className="sideLandingDiv" onClick={projectdashboard}>
                        <img className=""  style={{borderRadius:"20px",width:"104%"}}src={pjdimages}/><br/>
                            </div>
                    <div className="prdimg"><p align="center">Project Dashboard</p></div> */}
                        <div className="sideLandingDiv" onClick={darwinfn}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={darwinimages} /><br />
                        </div>
                        <div className="eolimg"><p align="center">Anchor</p></div>
                        <div className="sideLandingDiv" onClick={switchionfn}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={ionimages} /><br />
                        </div>
                        <div className="prdimg"><p align="center">Switch iON</p></div>
                        {/* <div className="topLandingDiv" onClick={projectdashboard}><p align="center">Project Dashboard</p></div> */}
                        <div className="sideLandingDiv" onClick={redirectOnlineapproval}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={onlineimages} /><br />
                        </div>
                        <div className="oneimg"><p align="center">Online Approval</p></div>
                        {/* <div className="sideLandingDiv" onClick={redirectOnlineapproval}><p align="center">Online Approval</p></div> */}
                        <div className="sideLandingDiv" onClick={leymobile}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={econnectimages} /><br />
                        </div>
                        <div className="econimg"><p align="center">LeyMobile</p></div>
                        {/* <div className="topLandingDiv" onClick={leymobile}><p align="center">LeyMobile</p></div> */}
                        {/* <div className="topLandingDiv" onClick={onLeaveTab}><p align="center">Leave</p></div> */}
                        <div className="sideLandingDiv" onClick={redirectMyContract}>
                            <img className="" style={{ borderRadius: "20px", width: "104%" }} src={clmimages} /><br />
                        </div>
                        <div className="clmimg"><p align="center">My Contracts</p></div>
                        {/* <div className="sideLandingDiv" onClick={redirectMyContract}><p align="center">My Contracts</p></div> */}
                    </div>
                </div>
            </div>
            {/* <div className="approval-landing">
                <div className="approval-heading">   
                    <span>Approve Leave Request</span>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/>
                <ApprovalTable/>
            </div> */}

        </>
    )
}

